import type { FunctionComponent } from 'react';

import { Allium, Demo, Etika, Humm, Novuna, Omni, Propensio } from './Lenders';
import Generic from './StatusComponent/Generic';
import useStatusContent from './useStatusContent';

const Content: FunctionComponent = () => {
  const { provider, isFinanced, isLoading, isPaidByBank, isPaidByCard } =
    useStatusContent();

  if (isLoading) return <Generic.Loading />;
  if (isPaidByCard) return <Generic.PaidByCard />;
  if (isPaidByBank) return <Generic.PaidByBank />;
  if (!provider || !isFinanced) return <Generic.JobStatus />;

  return (
    <>
      {provider === 'allium' && <Allium />}
      {provider === 'demo' && <Demo />}
      {provider === 'etika' && <Etika />}
      {provider === 'novuna' && <Novuna />}
      {provider === 'omni' && <Omni />}
      {provider === 'propensio' && <Propensio />}
      {provider === 'humm' && <Humm />}
    </>
  );
};

export default Content;
